// START_MODULE pages_main_sections_contacts_styled_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import styled from 'styled-components';

export const ContactsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;

  @media (max-width: 1000px) {
    justify-content: center;
  }
`;

// END_MODULE pages_main_sections_contacts_styled_ts
